const sanitizeHtml = require('sanitize-html');

const ALLOWED_TAGS = sanitizeHtml.defaults.allowedTags.concat([
    'img',
    'iframe',
    'video',
    'audio',
    'source',
]);

const SANITIZE_OPTIONS = {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: {
        '*': ['class', 'title', 'aria-label', 'aria-hidden'],
        a: ['href', 'name', 'target', 'rel'],
        h1: ['id'],
        h2: ['id'],
        h3: ['id'],
        h4: ['id'],
        h5: ['id'],
        h6: ['id'],
        img: ['src', 'srcset', 'sizes', 'alt', 'width', 'height', 'loading'],
        iframe: [
            'src',
            'title',
            'width',
            'height',
            'allow',
            'allowfullscreen',
            'frameborder',
            'loading',
            'referrerpolicy',
            'sandbox',
        ],
        video: ['src', 'poster', 'width', 'height', 'controls', 'preload'],
        audio: ['src', 'controls', 'preload'],
        source: ['src', 'srcset', 'sizes', 'type', 'media'],
        table: ['width', 'cellpadding', 'cellspacing'],
        col: ['span', 'width'],
        colgroup: ['span', 'width'],
        td: ['colspan', 'rowspan', 'width'],
        th: ['colspan', 'rowspan', 'scope', 'width'],
    },
    allowedSchemes: ['http', 'https', 'mailto', 'tel'],
    allowedSchemesByTag: {
        img: ['http', 'https'],
        iframe: ['https'],
        source: ['http', 'https'],
        video: ['http', 'https'],
        audio: ['http', 'https'],
    },
    allowProtocolRelative: false,
    allowedIframeHostnames: [
        'www.google.com',
        'maps.google.com',
        'www.youtube.com',
        'youtube.com',
        'www.youtube-nocookie.com',
        'player.vimeo.com',
    ],
    nonTextTags: ['style', 'script', 'textarea', 'option', 'xmp', 'noscript', 'template'],
    transformTags: {
        a: (tagName, attributes) => {
            const transformed = {...attributes};
            const allowedRelValues = new Set(['nofollow', 'ugc', 'sponsored']);
            const rel = new Set(
                (transformed.rel || '')
                    .split(/\s+/)
                    .filter(value => allowedRelValues.has(value.toLowerCase()))
                    .map(value => value.toLowerCase()),
            );

            if (transformed.target === '_blank') {
                rel.add('noopener');
                rel.add('noreferrer');
            } else {
                delete transformed.target;
            }

            if (rel.size) transformed.rel = Array.from(rel).join(' ');
            else delete transformed.rel;

            return {tagName, attribs: transformed};
        },
        iframe: (tagName, attributes) => ({
            tagName,
            attribs: {
                ...attributes,
                allow: 'fullscreen; picture-in-picture; encrypted-media',
                loading: 'lazy',
                referrerpolicy: 'strict-origin-when-cross-origin',
                sandbox: 'allow-scripts allow-same-origin allow-presentation allow-popups',
            },
        }),
    },
    // Inline styles are intentionally absent from allowedAttributes. This prevents
    // CSS-based payloads and keeps deterministic output during SSR and hydration.
};

function sanitizeCmsHtml(value) {
    if (typeof value !== 'string' || !value) return '';
    return sanitizeHtml(value, SANITIZE_OPTIONS);
}

function safeHtml(value) {
    return {__html: sanitizeCmsHtml(value)};
}

module.exports = {
    SANITIZE_OPTIONS,
    safeHtml,
    sanitizeCmsHtml,
};
